module.exports = __WEBPACK_EXTERNAL_MODULE_381__;


//////////////////
// WEBPACK FOOTER
// external {"root":"numbro","commonjs2":"numbro","commonjs":"numbro","amd":"numbro"}
// module id = 381
// module chunks = 0